var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8359 0.173096H3.16406C1.4194 0.173096 0 1.59249 0 3.33716V24.009C0 25.7537 1.4194 27.1731 3.16406 27.1731H23.8359C25.5806 27.1731 27 25.7537 27 24.009V3.33716C27 1.59249 25.5806 0.173096 23.8359 0.173096ZM24.8906 24.009C24.8906 24.5906 24.4175 25.0637 23.8359 25.0637H17.8242V16.468H21.0827L21.6211 13.1985H17.8242V10.9309C17.8242 10.0357 18.5111 9.34888 19.4062 9.34888H21.5684V6.07935H19.4062C16.7209 6.07935 14.5558 8.25464 14.5558 10.9401V13.1985H11.3906V16.468H14.5558V25.0637H3.16406C2.58251 25.0637 2.10938 24.5906 2.10938 24.009V3.33716C2.10938 2.7556 2.58251 2.28247 3.16406 2.28247H23.8359C24.4175 2.28247 24.8906 2.7556 24.8906 3.33716V24.009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0 0.173096)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f7b31e5a3d65f0506495ebc66e76d0d6.svg";
export { ForwardRef as ReactComponent };